'use es6';

import { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { Flex } from 'foundations-components/components/Flex';
import { ListItem } from 'foundations-components/transitional/components/List';
import { Text } from 'foundations-components/components/Text';
import BestPracticesPopover from 'page-editor-ui/components/BestPracticesPopover';
import MABControls from 'ContentEditorUI/components/header/MABControls';
import MABTestManagerModal from 'page-editor-ui/components/MABTestManagerModal';
import { getIsMABEditable, getIsMABWithoutAccess, getMABExperimentMetric, getMABExperimentPrimayVariantName } from 'ContentEditorUI/redux/selectors/mabExperimentSelectors';
import { isNewMabTest, removeTemporaryNewMABTestBitIfNeeded } from 'ContentEditorUI/utils/temporaryLocalStorageState';
import { autoSave as autoSaveAction } from 'page-editor-ui/redux/actions/pageSaveActions';
import { TestVariationTours, TestVariationTourSecondStep, useTestVariationApprovalTour } from '../components/TestVariationTours';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => ({
  isMABEditable: getIsMABEditable(state),
  isMABWithoutAccess: getIsMABWithoutAccess(state),
  mabMetric: getMABExperimentMetric(state)
});
const PageMABControlsContainer = ({
  autoSave,
  isMABEditable,
  isMABWithoutAccess,
  mabMetric
}) => {
  const [showMabManagerModal, setShowMabManagerModal] = useState(false);
  const primaryVariationName = useSelector(getMABExperimentPrimayVariantName);
  useEffect(() => {
    removeTemporaryNewMABTestBitIfNeeded();
  }, []);
  const handleManageTestClick = () => {
    setShowMabManagerModal(true);
  };
  const handleManagerModalClose = () => {
    setShowMabManagerModal(false);
  };
  const {
    goToStepTwo,
    endTour
  } = useTestVariationApprovalTour();
  function renderPopover() {
    if (!isMABEditable) return null;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(BestPracticesPopover, {
        mabMetric: mabMetric,
        showInitialPopover: isNewMabTest(),
        test: "mab"
      }), /*#__PURE__*/_jsx(MABTestManagerModal, {
        onClose: handleManagerModalClose,
        show: showMabManagerModal
      })]
    });
  }
  if (!isMABEditable && !isMABWithoutAccess) {
    return null;
  }
  return /*#__PURE__*/_jsx(ListItem, {
    children: /*#__PURE__*/_jsx(TestVariationTours, {
      name: primaryVariationName,
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "div",
          typography: "body-100",
          children: /*#__PURE__*/_jsx(MABControls, {
            onManageTestClick: handleManageTestClick,
            autoSave: autoSave,
            TestVariationTourSecondStep: TestVariationTourSecondStep,
            goToStepTwo: goToStepTwo,
            endTour: endTour
          })
        }), renderPopover()]
      })
    })
  });
};
PageMABControlsContainer.propTypes = {
  isMABEditable: PropTypes.bool.isRequired,
  isMABWithoutAccess: PropTypes.bool.isRequired,
  mabMetric: PropTypes.string.isRequired,
  autoSave: PropTypes.func.isRequired
};
export default connect(mapStateToProps, {
  autoSave: autoSaveAction
})(PageMABControlsContainer);